import { FormControl, FormHelperText, TextField } from "@mui/material";
import { FC, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import {
  getRegisterAttributes,
  ICustomField,
  ValidationHelpers,
} from "@ryde/shared";

import { FullWidthTextFieldWrapper } from "../parts-styled";

export const PasswordTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  formValidation,
  formAttributes,
}) => {
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const { disabled } = getRegisterAttributes(formAttributes);
  const requiredComputed = useMemo(() => {
    return ValidationHelpers.hasRequiredRule(formValidation);
  }, [formValidation]);

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({
          field: { value, ...fieldRestProps },
          fieldState: { error },
        }) => (
          <FormControl
            data-e2e-template="password-template"
            required={requiredComputed}
            error={!!error}
          >
            <TextField
              value={value || ""}
              {...fieldRestProps}
              label={formLabelTranslated}
              required={requiredComputed}
              disabled={disabled}
              error={!!error}
              fullWidth
              type="password"
              data-e2e-template="password-template"
            />
            {error && (
              <FormHelperText data-e2e="password-template-error">
                {error.message}
              </FormHelperText>
            )}
          </FormControl>
        )}
      />
    </FullWidthTextFieldWrapper>
  );
};
